// generated by the plop

import { TabModel } from '../../symbols';

export interface TabsNavStateModel {
  tabs: TabModel[];
  tabsQueue: TabModel[];
  tabIndexSelected: number;
}

export const TABS_NAV_STATE_DEFAULT: TabsNavStateModel = {
  tabs: [],
  tabsQueue: [],
  tabIndexSelected: null
};
